export const translations = {
  en: {
    title: "Formatting Service",
    subtitle: "Format JSON, SQL, YAML and code online",
    json: "JSON",
    sql: "SQL",
    yaml: "YAML",
    code: "Code",
    jsonTitle: "JSON Formatting",
    sqlTitle: "SQL Formatting",
    yamlTitle: "YAML Formatting",
    codeTitle: "Code Formatting",
    input: "Input:",
    output: "Result:",
    clear: "Clear",
    format: "Format",
    copy: "Copy Result",
    languageSelect: "Programming language:",
    languages: {
      javascript: "JavaScript",
      python: "Python",
      java: "Java",
      cpp: "C++",
      html: "HTML",
      css: "CSS"
    },
    placeholders: {
      json: 'Enter JSON, e.g.: {"name":"John","age":30,"city":"New York"}',
      sql: 'Enter SQL query, e.g.: SELECT * FROM users WHERE age > 18 ORDER BY name',
      yaml: 'Enter YAML, e.g.: name: John\nage: 30\ncity: New York',
      code: (lang) => `Enter ${lang} code, e.g.: function hello(){console.log("Hello World");}`
    },
    copySuccess: "Copied!",
    copyError: "Copy error: ",
    theme: "Theme",
    language: "Language",
    footer: "2024 Formatting Service",
    error: "Error"
  },
  ru: {
    title: "Сервис форматирования",
    subtitle: "Форматируйте JSON, SQL, YAML и код онлайн",
    json: "JSON",
    sql: "SQL",
    yaml: "YAML",
    code: "Код",
    jsonTitle: "Форматирование JSON",
    sqlTitle: "Форматирование SQL",
    yamlTitle: "Форматирование YAML",
    codeTitle: "Форматирование кода",
    input: "Ввод:",
    output: "Результат:",
    clear: "Очистить",
    format: "Форматировать",
    copy: "Копировать результат",
    languageSelect: "Язык программирования:",
    languages: {
      javascript: "JavaScript",
      python: "Python",
      java: "Java",
      cpp: "C++",
      html: "HTML",
      css: "CSS"
    },
    placeholders: {
      json: 'Введите JSON, например: {"name":"John","age":30,"city":"New York"}',
      sql: 'Введите SQL запрос, например: SELECT * FROM users WHERE age > 18 ORDER BY name',
      yaml: 'Введите YAML, например: name: John\nage: 30\ncity: New York',
      code: (lang) => `Введите код на ${lang}, например: function hello(){console.log("Hello World");}`
    },
    copySuccess: "Скопировано!",
    copyError: "Ошибка копирования: ",
    theme: "Тема",
    language: "Язык",
    footer: "2024 Сервис форматирования.",
    error: "Ошибка"
  }
};

export const themeVariables = {
  light: {
    '--primary-color': '#3b82f6',
    '--secondary-color': '#8b5cf6',
    '--bg-color': '#f8fafc',
    '--text-color': '#1e293b',
    '--container-bg': '#ffffff',
    '--input-bg': '#ffffff',
    '--input-border': '#cbd5e1',
    '--button-bg': '#475569',
    '--button-color': '#ffffff',
    '--button-text': '#ffffff',
    '--button-light-bg': '#e2e8f0',
    '--button-light-text': '#334155',
    '--header-bg': 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
    '--footer-color': '#475569',
    '--tab-bg': 'rgba(255, 255, 255, 0.2)',
    '--tab-active-bg': '#ffffff',
    '--tab-color': '#ffffff',
    '--tab-active-color': '#3b82f6',
    '--textarea-readonly-bg': '#f1f5f9',
    '--select-bg': '#ffffff',
    '--select-border': '#cbd5e1',
    '--select-color': '#1e293b',
    '--shadow-color': 'rgba(0, 0, 0, 0.08)',
    '--border-radius': '10px',
    '--transition-speed': '0.2s',
    '--hover-brightness': '1.05',
    '--focus-shadow': '0 0 0 3px rgba(59, 130, 246, 0.15)',
    '--label-bg': '#f1f5f9',
    '--label-color': '#475569',
    '--error-color': '#dc2626',
    '--success-color': '#059669',
    '--warning-color': '#d97706'
  },
  dark: {
    '--primary-color': '#60a5fa',
    '--secondary-color': '#a78bfa',
    '--bg-color': '#0f172a',
    '--text-color': '#f1f5f9',
    '--container-bg': '#1e293b',
    '--input-bg': '#334155',
    '--input-border': '#475569',
    '--button-bg': '#475569',
    '--button-color': '#f1f5f9',
    '--button-text': '#f1f5f9',
    '--button-light-bg': '#334155',
    '--button-light-text': '#f1f5f9',
    '--header-bg': 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
    '--footer-color': '#94a3b8',
    '--tab-bg': 'rgba(255, 255, 255, 0.1)',
    '--tab-active-bg': '#334155',
    '--tab-color': '#f1f5f9',
    '--tab-active-color': '#60a5fa',
    '--textarea-readonly-bg': '#1e293b',
    '--select-bg': '#334155',
    '--select-border': '#475569',
    '--select-color': '#f1f5f9',
    '--shadow-color': 'rgba(0, 0, 0, 0.25)',
    '--border-radius': '10px',
    '--transition-speed': '0.2s',
    '--hover-brightness': '1.1',
    '--focus-shadow': '0 0 0 3px rgba(96, 165, 250, 0.2)',
    '--label-bg': '#334155',
    '--label-color': '#cbd5e1',
    '--error-color': '#f87171',
    '--success-color': '#34d399',
    '--warning-color': '#fbbf24'
  }
};